import './HydrologistButton.scss'
export let HydrologistButton = ({ title, type, className}) => {
  return (
    <div className={`HydrologistButton ${className}`}>
      <button type={type} className="button-three">{title}</button>
    </div>
  )
}